export default __webpack_public_path__ + "static/media/ureward_icon_white.218deb3e.png";